import React, { useState } from 'react';
import { Button, styled, Typography } from '@mui/material';
import { EditOutlined } from '@mui/icons-material';
import { moneyFormat } from 'helpers/moneyFormat';
import EditChargedValueDialog from '../dialog/EditChargedValueDialog';
import { palette } from './GuidedSurgerie';

const Box = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: theme.spacing(1.5),
  padding: theme.spacing(1, 1.5),
  border: `1px solid ${palette.primary}`,
  borderRadius: 8,
  background: '#fff',
}));

interface ChargedValueProps {
  title: string;
  value?: number;
  min?: number;
  max?: number;
  onChange(value: number): void;
}

// Valor cobrado do médico/hospital: leitura direta no cartão e edição em diálogo, como anestesista e pacote.
const ChargedValue: React.FC<ChargedValueProps> = ({ title, value, min, max, onChange }) => {
  const [editing, setEditing] = useState(false);

  return (
    <div onClick={e => e.stopPropagation()}>
      <Box>
        <div>
          <Typography variant="caption" color="textSecondary" display="block">
            Valor cobrado
          </Typography>
          <Typography variant="subtitle1" fontWeight={800} color={palette.ink}>
            {moneyFormat(value || 0)}
          </Typography>
        </div>
        <Button size="small" startIcon={<EditOutlined />} onClick={() => setEditing(true)}>
          Editar valor
        </Button>
      </Box>

      {editing && (
        <EditChargedValueDialog
          title={title}
          value={value || 0}
          min={min}
          max={max}
          onSave={onChange}
          onExited={() => setEditing(false)}
        />
      )}
    </div>
  );
};

export default ChargedValue;
